// required for correct centering with inputs
const currencyMaskOptions = {
  prefix: '$',
  type: 'money',
  includeThousandsSeparator: true,
  allowDecimal: false,
  requireDecimal: false,
  allowLeadingZeroes: false
};
const defaultRateLabel = 'National Average Rate';
const tabLabels = {
  finance: 'Finance',
  lease: 'Lease',
  cash: 'Cash'
};
const loanTermOptions = [36, 48, 60, 72];
const loanTermOptionsExcellentTier = [36, 48, 60, 72, 84];
var ndsConstants = {
  currencyMaskOptions,
  defaultRateLabel,
  loanTermOptions,
  tabLabels,
  loanTermOptionsExcellentTier
};
export { ndsConstants as default };
